/**
 * Portuguese Products Translations
 * Product page translation module - Portuguese
 */

import type { ProductsTranslations } from '../../types';

export const ptProducts: ProductsTranslations = {
  title: 'Todos os produtos',
  subtitle: 'Descubra a solução de aquecimento perfeita para seu espaço',
  viewDetails: 'Ver Detalhes',
  header: {
    title: 'Todos os produtos',
    subtitle: 'Descubra a solução de aquecimento perfeita para sua casa, escritório ou espaço industrial.',
  },
  filters: {
    all: 'Todos',
    searchPlaceholder: 'Buscar produtos...',
  },
  catalog: 'Baixar Catálogo Completo',
  discoverMore: 'Descubra Mais',
  viewSpecs: 'Ver Especificações',
  categories: {
    infraredHeater: 'Aquecedor de Infravermelho',
    portableHeater: 'Aquecedor Portátil',
    gasHeater: 'Aquecedores a gás',
  },
  navDesc: {
    infrared: 'Painéis radiantes de parede e teto',
    portable: 'De piso, de mesa e suspensos',
    gas: 'Aquecedores e mesas de fogo',
  },
  viewAllProducts: 'Ver todos os produtos',
  gasSubtitle: 'Aquecedores a gás e mesas de fogo para varandas e espaços ao ar livre.',
  categoryLanding: {
    gas: {
      title: 'Aquecedores a gás e mesas de fogo',
      subtitle:
        'Aquecimento ao ar livre de 8 kW a 50.000 BTU, com queimadores em aço inoxidável 304, quebra-ventos de vidro e configurações GLP para o seu mercado de destino.',
      empty: 'Nenhum produto encontrado nesta categoria.',
    },
    infrared: {
      title: 'Aquecedores de Infravermelho',
      subtitle: 'Calor radiante pensado para aquecimento eficiente e direcionado—ideal para varandas, oficinas e zonas de conforto.',
      empty: 'Nenhum produto encontrado nesta categoria.',
    },
    portable: {
      title: 'Aquecedores Portáteis',
      subtitle: 'Soluções de aquecimento flexíveis para casa e trabalho—fáceis de mover, rápidas para aquecer, feitas para o conforto do dia a dia.',
      empty: 'Nenhum produto encontrado nesta categoria.',
    },
  },
  detail: {
    technicalSpecs: 'Especificações Técnicas',
    relatedProducts: 'Produtos relacionados de {{category}}',
    requestQuote: 'Solicitar Cotação',
    backToProducts: 'Voltar aos Produtos',
    productNotFound: 'Produto não encontrado',
    specsAvailableOnRequest: 'Especificações disponíveis mediante solicitação.',
    noMatchingProducts: 'Nenhum produto correspondente',
    noProducts: 'Sem dados de produtos',
  },
  items: {
    p1: {
      name: 'Serie 13A',
      description: 'Série confiável de aquecedores radiantes por infravermelho longo, com múltiplas opções de potência. Ideal para pátios, restaurantes, oficinas e montagem na parede. Eficiência energética com proteção IPX4.',
      longDescription:
        'Soluções de aquecimento radiante eficazes para quem aprecia ambiente elegante e calor. O aquecimento por infravermelho é a forma perfeita de aquecer um espaço sem a secura empoeirada do aquecimento por convecção tradicional, com excelente eficiência energética, reduzindo o consumo elétrico em até 80%. Os aquecedores JH são usados predominantemente em pátios, varandas semiabertas, restaurantes e oficinas. Possui elementos de aquecimento aeroespaciais duráveis com placa de aquecimento arqueada, adequados para montagem na parede com classificação IPX4.',
      category: 'Aquecedor de Infravermelho',
      features: ['Ecológico', 'Seguro e Silencioso', 'Longa Vida Útil', '350°C Alta Temp'],
      specs: [
        { label: 'Modelo', value: 'NR10/18/24/32/40-13A' },
        { label: 'Potência', value: '2400W' },
        { label: 'Área de Cobertura', value: '30 m²' },
        { label: 'Tensão/Frequência', value: '230V, 50/60Hz' },
        { label: 'Corrente Nominal', value: '10.4A' },
        { label: 'Temperatura Superficial', value: '300°C' },
        { label: 'Dimensões', value: '1500×189×67mm' },
        { label: 'Peso L/B', value: '8.8/10.6 kg' },
      ],
    },
    p2: {
      name: 'Serie 13B',
      description: 'Série de aquecedores radiantes por infravermelho longo com controle remoto e indicador LED. Eficiência energética para interiores, oficinas e restaurantes. Montagem na parede com proteção IPX4.',
      longDescription:
        'A Série 13B apresenta design clássico e leve com excelente desempenho por eficiência energética. Equipada com termostato e controle remoto, oferece operação conveniente com indicador LED vermelho. Os elementos de aquecimento aeroespaciais duráveis com placa arqueada proporcionam ampla cobertura radiante e taxa de conversão elétrica de até 99%. Ideal para salas de estar, quartos, restaurantes e oficinas. Montagem na parede com classificação IPX4.',
      category: 'Aquecedor de Infravermelho',
      features: ['Controle Remoto', 'Indicador LED', 'Ecológico', 'Alta Eficiência', 'Superfície 300°C'],
      specs: [
        { label: 'Modelo', value: 'NR10/18/24/32-13B' },
        { label: 'Potência', value: '2400W' },
        { label: 'Área de Cobertura', value: '30 m²' },
        { label: 'Tensão/Frequência', value: '230V, 50/60Hz' },
        { label: 'Corrente Nominal', value: '10.4A' },
        { label: 'Temperatura Superficial', value: '300°C' },
        { label: 'Dimensões', value: '1500×189×67mm' },
        { label: 'Peso L/B', value: '8.8/10.6 kg' },
      ],
    },
    p3: {
      name: 'Serie 13C',
      description: 'Série de aquecedores radiantes por infravermelho longo com alto-falante Bluetooth integrado para pátios, restaurantes e espaços semiabertos. Eficiência energética com montagem na parede e proteção IPX4.',
      longDescription:
        'A série 13C foi desenvolvida para pátios e espaços semiabertos, com alto-falante Bluetooth integrado para reproduzir música enquanto fornece aquecimento radiante por infravermelho longo. É possível conectar um celular ou outro dispositivo compatível para áudio, mas a função Bluetooth não controla a potência nem a temperatura do aquecedor. Possui 4 níveis de potência com excelente eficiência energética: 25%, 50%, 75% e 100%. O painel de aquecimento recebe revestimento NANO especial para melhorar a emissividade infravermelha. Ideal para restaurantes e oficinas com montagem na parede, classificação IPX4.',
      category: 'Aquecedor de Infravermelho',
      features: ['Alto-falante Bluetooth', '4 Níveis de Potência', 'Conforto por Infravermelho', 'Áudio Bluetooth', 'Operação Silenciosa'],
      specs: [
        { label: 'Modelo', value: 'NR10/18/24/32-13C' },
        { label: 'Potência', value: '1800W' },
        { label: 'Área de Cobertura', value: '20 m²' },
        { label: 'Tensão/Frequência', value: '230V, 50/60Hz' },
        { label: 'Corrente Nominal', value: '7.8A' },
        { label: 'Temperatura Superficial', value: '300°C' },
        { label: 'Dimensões', value: '1370×189×67mm' },
        { label: 'Peso L/B', value: '8.3/10.2 kg' },
        { label: 'Carga de Contentor', value: '705/1632; 480/1156; 355/884; 270/612' },
      ],
    },
    p4: {
      name: 'Serie 22B',
      description: 'Aquecedor radiante de painel de cerâmica vidrada premium com controle de app WiFi Tuya. Eficiência energética e aquecimento rápido para pátios, restaurantes e oficinas. Montagem na parede com proteção IPX4.',
      longDescription:
        'JH-NR22-22B apresenta painéis de aquecimento radiante de cerâmica vidrada premium que aquecem rapidamente e uniformemente, com resistência ao calor de até 950°C. O efeito especial de reflexão do vidro cria um visual moderno deslumbrante para qualquer ambiente. Equipado com controle remoto e suporte de app WiFi Tuya para operação conveniente. Proporciona aquecimento limpo com excelente eficiência energética, sem ruído, sem vento e sem secura. Ideal para pátios, restaurantes e oficinas. Montagem na parede com classificação IPX4.',
      category: 'Aquecedor de Infravermelho',
      features: ['App WiFi Tuya', 'Controle Remoto', 'Painel Cerâmico Vidrado', 'Aquecimento Rápido', 'Cuidados com a Saúde'],
      specs: [
        { label: 'Modelo', value: 'NR16/22/32-22B' },
        { label: 'Potência', value: '1.6/2.2/3.2 kW' },
        { label: 'Área de cobertura', value: '20/30/40 m²' },
        { label: 'Tensão/Frequência', value: '220-240V~50/60Hz' },
        { label: 'Corrente nominal', value: '7/9.6/13.9A' },
        { label: 'Temperatura da superfície', value: '380°C' },
        { label: 'Dimensões', value: '810/1160/1660 × 180 × 77 mm' },
        { label: 'Peso N/G', value: '5/6.1; 7/8.2; 9.9/11.7 kg' },
        { label: 'Carga de contêiner', value: '728/1638; 507/1162; 377/826' },
      ]
    },
    p5: {
      name: 'Serie 13W',
      description: 'Série inteligente de aquecedores radiantes por infravermelho longo com app WiFi Tuya e controle remoto LCD. Eficiência energética para pátios, restaurantes e oficinas. Montagem na parede com proteção IPX4.',
      longDescription:
        "A série 13W combina app Tuya WiFi, controle LCD, visor LED e quatro níveis de potência. Para interiores e terraços ou varandas cobertos com parede adequada, use suportes compatíveis e os afastamentos do modelo. IPX4 indica proteção contra respingos.",
      category: 'Aquecedor de Infravermelho',
      features: ['App WiFi Tuya', 'Display LED', 'Controle Remoto LCD', '4 N\u00edveis de Pot\u00eancia', 'IPX4 Resistente \u00e0 \u00c1gua'],
      specs: [
        { label: 'Modelo', value: 'NR10/18/24/32-13W' },
        { label: 'Potência', value: '1.0/1.8/2.4/3.2 kW' },
        { label: 'Área de cobertura', value: '10/20/30/40 m²' },
        { label: 'Tensão/Frequência', value: '220-240V~50/60Hz' },
        { label: 'Corrente nominal', value: '4.3/7.8/10.4/13.9A' },
        { label: 'Temperatura da superfície', value: '300°C' },
        { label: 'Dimensões', value: '755/1150/1655/2155 × 189 × 67 mm' },
        { label: 'Peso N/G', value: '4.4/5.5; 6.9/8.1; 9.5/11.3; 12.3/14.3 kg' },
        { label: 'Carga de contêiner', value: '840/1680/2100; 530/1080/1350; 570/900/980; 350/700/800' },
      ]
    },
    p6: {
      name: 'Serie 14A',
      description: 'Aquecedor radiante de infravermelho longo de design arqueado clássico com múltiplas opções de potência. Perfeito para pátios, restaurantes, oficinas e montagem na parede. Eficiência energética com proteção IPX4.',
      longDescription:
        "A série 14A usa painel arqueado com nanorrevestimento e potências de 1000W a 4000W, sem controlador integrado. Escolha uma parede adequada em ambiente interno ou coberto e confirme suportes, afastamentos e controle do modelo. IPX4 indica proteção contra respingos.",
      category: 'Aquecedor de Infravermelho',
      features: ['Design Arqueado', 'Potência Múltipla', 'IPX4 Resistente à Água', 'Aquecimento Rápido', 'Eficiente Energético'],
      specs: [
        { label: 'Modelo', value: '' },
        { label: 'Potência', value: '' },
        { label: 'Área de cobertura', value: '' },
        { label: 'Tensão/Frequência', value: '' },
        { label: 'Corrente nominal', value: '' },
        { label: 'Temperatura da superfície', value: '' },
        { label: 'Dimensões', value: '' },
        { label: 'Peso N/G', value: '' },
        { label: 'Carga de contêiner', value: '' },
      ]
    },
    p7: {
      name: 'Serie 14B',
      description: "Aquecedor infravermelho de parede com controle remoto para interiores e terraços cobertos com parede adequada.",
      longDescription:
        "A série 14B combina painel arqueado com nanorrevestimento, controle remoto, LED, quatro níveis de potência e timer de 0/2/4/6/8 horas. Instale em parede adequada em ambiente interno ou coberto, com suportes compatíveis e afastamentos indicados. O perfil fino não implica compatibilidade com outras estruturas.",
      category: 'Aquecedor de Infravermelho',
      features: ['Controle Remoto', 'Função Timer', 'Design Arqueado', 'IPX4 Resistente à Água', 'Aquecimento Rápido'],
      specs: [
        { label: 'Modelo', value: '' },
        { label: 'Potência', value: '' },
        { label: 'Área de cobertura', value: '' },
        { label: 'Tensão/Frequência', value: '' },
        { label: 'Corrente nominal', value: '' },
        { label: 'Temperatura da superfície', value: '' },
        { label: 'Dimensões', value: '' },
        { label: 'Peso N/G', value: '' },
        { label: 'Carga de contêiner', value: '' },
      ]
    },
    p8: {
      name: 'Serie 23W',
      description: 'Aquecedor infravermelho ultrafino com app WiFi Tuya Smart, controlo por voz, comando e temporizador para interiores e terraços cobertos.',
      longDescription:
        "A série 23W combina painel preto fino com nanorrevestimento, app Tuya Smart WiFi e comandos de voz compatíveis. O controle oferece quatro níveis de potência e timer de 0/2/4/6/8 horas. Instale em parede adequada em ambiente interno ou coberto com os suportes e afastamentos do modelo.",
      category: 'Aquecedor de Infravermelho',
      features: ['App Tuya Smart', 'Controlo por Voz', 'Controlo Remoto', 'Função Temporizador', '4 Níveis de Potência', 'Aquecimento Rápido'],
      specs: [
        { label: 'Modelo', value: 'NR10/18/24/32-23W' },
        { label: 'Potência', value: '1.0/1.8/2.4/3.2 kW' },
        { label: 'Área de cobertura', value: '10/20/30/40 m²' },
        { label: 'Tensão/Frequência', value: '220-240V~50/60Hz' },
        { label: 'Corrente nominal', value: '4.3/7.8/10.4/13.9A' },
        { label: 'Temperatura da superfície', value: '300°C' },
        { label: 'Dimensões', value: '693/1093/1593/2093 × 151 × 52 mm' },
        { label: 'Peso N/G', value: '3.4/4.2; 5.3/6.4; 7.6/9.5; 9.9/12.5 kg' },
        { label: 'Carga de contêiner', value: '1248; 800; 528; 412 (20HQ)' },
      ]
    },
    p20: {
      name: 'Serie 23A',
      description: 'Aquecedor infravermelho ultrafino com comando convencional, temporizador e 4 níveis de potência, sem WiFi nem app.',
      longDescription:
        'A série 23A é um aquecedor infravermelho ultrafino operado por um comando convencional, sem ligação WiFi nem app. O comando oferece 4 níveis de potência (25%/50%/75%/100%) e temporizador de 0/2/4/6/8 horas. O painel preto com nanorrevestimento fornece calor radiante rápido, uniforme, silencioso e sem chama. Disponível de 1000W a 3200W para 10-40 m²; o perfil de 52 mm é ideal para casas, restaurantes, escritórios e terraços cobertos.',
      category: 'Aquecedor de Infravermelho',
      features: ['Controle Remoto', 'Função Timer', '4 Níveis de Potência', 'Design Fino', 'Aquecimento Rápido', 'Funcionamento Silencioso'],
      specs: [
        { label: 'Modelo', value: '' },
        { label: 'Potência', value: '' },
        { label: 'Área de cobertura', value: '' },
        { label: 'Tensão/Frequência', value: '' },
        { label: 'Corrente nominal', value: '' },
        { label: 'Temperatura da superfície', value: '' },
        { label: 'Dimensões', value: '' },
        { label: 'Peso N/G', value: '' },
        { label: 'Carga de contêiner', value: '' },
      ]
    },
    p21: {
      name: 'Série 25W',
      description: 'Aquecedor de infravermelhos distantes de parede com WiFi integrado, controlo pela app Tuya, visor LED de nível e quatro potências de 1000 W a 3200 W.',
      longDescription:
        'A Série 25W é um aquecedor de infravermelhos distantes de parede e perfil fino, com WiFi integrado para controlo pela app Tuya Smart: ligue o painel, mude o nível de potência e defina horários pelo telemóvel, ou use o comando sem fios incluído com o seu botão de emparelhamento WiFi. O visor LED vermelho da caixa de controlo mostra o nível de potência ativo. Quatro níveis de potência vão de 1000 W a 3200 W e cobrem de 10 m² a 40 m², e todos os modelos partilham o mesmo corpo de alumínio de 67 mm. Um elemento de aquecimento de infravermelhos distantes em espiral percorre o painel dentro de um corpo de alumínio extrudido e leva a face de alumínio ranhurada a 300 °C de temperatura de superfície.',
      category: 'Aquecedor de Infravermelho',
      features: ['App WiFi Tuya', 'Visor LED de Nível', 'Comando Sem Fios', '4 Níveis de Potência', 'Superfície a 300 °C', 'Corpo de 67 mm'],
      specs: [
        { label: 'Modelo', value: 'NR10/18/24/32-25W' },
        { label: 'Potência', value: '1.0/1.8/2.4/3.2 kW' },
        { label: 'Área de cobertura', value: '10/20/30/40 m²' },
        { label: 'Tensão/Frequência', value: '220-240V~50/60Hz' },
        { label: 'Corrente nominal', value: '4.3/7.8/10.4/13.9A' },
        { label: 'Temperatura da superfície', value: '300°C' },
        { label: 'Dimensões', value: '715/1115/1615/2115 × 189 × 67 mm' },
        { label: 'Peso N/G', value: '4.4/5.5; 6.9/8.1; 9.5/11.3; 12.3/14.3 kg' },
        { label: 'Carga de contêiner', value: '945/1920/2176; 615/1290/1462; 435/885/1003; 345/705/799' },
      ]
    },
    p9: {
      name: 'JHL020A',
      description: 'Aquecedor de fibra de carbono compacto com proteção contra tombamento. Perfeito para aquecimento pessoal sob mesas ou mesas de trabalho.',
      longDescription:
        'JHL020A é um aquecedor de mesa eficiente e compacto projetado para aquecimento pessoal. Apresentando um tubo de aquecimento de fibra de carbono para distribuição rápida e uniforme do calor. Equipado com controle por interruptor alternador e proteção contra tombamento para segurança. O design de malha fria ao toque evita queimaduras acidentais enquanto proporciona aquecimento eficiente. A construção leve com plugue europeu o torna perfeito para uso doméstico ou de escritório.',
      category: 'Aquecedor Portátil',
      features: ['Proteção contra Tombamento', 'Malha Fria ao Toque', 'Design Compacto', 'Aquecimento Rápido', 'Eficiente Energético'],
      specs: [
        { label: 'Modelo', value: 'JHL020A' },
        { label: 'Nome do Produto', value: 'Aquecedor de Mesa' },
        { label: 'Tensão', value: '220-240V~50Hz' },
        { label: 'Potência', value: '1200W' },
        { label: 'Controle', value: 'Interruptor Alternador' },
        { label: 'Elemento de Aquecimento', value: '1 Tubo de Aquecimento de Fibra de Carbono' },
        { label: 'Plugue', value: 'Plugue Europeu' },
        { label: 'Cabo', value: '1.8-1.9m' },
        { label: 'Material', value: 'Ferro, Alumínio' }
      ]
    },
    p10: {
      name: 'JHL023',
      description: 'Aquecedor de fibra de carbono potente com configurações térmicas duplas e alça dobrável. Solução de aquecimento portátil para qualquer espaço.',
      longDescription:
        'JHL023 é um aquecedor de piso potente e portátil apresentando tubos duplos de aquecimento de fibra de carbono para calor eficiente. Duas configurações térmicas (750W + 750W) permitem controle flexível de temperatura. O interruptor rotativo proporciona operação fácil, enquanto a alça dobrável torna-o altamente portátil. Feito com construção durável de plástico e aço, este aquecedor é perfeito para salas de estar, quartos, escritórios ou qualquer espaço que precise de calor extra.',
      category: 'Aquecedor Portátil',
      features: ['Configurações Térmicas Duplas', 'Alça Dobrável', 'Aquecimento de Fibra de Carbono', 'Design Portátil', 'Operação Fácil'],
      specs: [
        { label: 'Modelo', value: 'JHL023' },
        { label: 'Nome do Produto', value: 'Aquecedor de Piso' },
        { label: 'Tensão', value: '220-240V~50Hz' },
        { label: 'Potência', value: '1500W (máx.)' },
        { label: 'Configurações', value: '750W + 750W' },
        { label: 'Controle', value: 'Interruptor Rotativo' },
        { label: 'Elemento de Aquecimento', value: 'Tubo de Aquecimento de Fibra de Carbono x 2' },
        { label: 'Plugue', value: 'Plugue Europeu' },
        { label: 'Cabo', value: '1.8-1.9m' },
        { label: 'Material', value: 'Plástico, Aço' },
        { label: 'Característica', value: 'Alça Dobrável' }
      ]
    },
    p11: {
      name: 'JHL023-05',
      description: 'Aquecedor de fibra de carbono compacto com configurações térmicas duplas. Aquecimento eficiente energeticamente para espaços pequenos e médios.',
      longDescription:
        'JHL023-05 é um aquecedor de piso compacto e eficiente energeticamente perfeito para espaços pequenos e médios. Apresentando tubos duplos de aquecimento de fibra de carbono com duas configurações ajustáveis (400W + 400W), proporciona aquecimento confortável enquanto economiza energia. O interruptor rotativo permite operação fácil, e a alça dobrável garante armazenamento e portabilidade convenientes. Ideal para quartos, escritórios domésticos ou espaços de trabalho pessoais.',
      category: 'Aquecedor Portátil',
      features: ['Configurações Térmicas Duplas', 'Alça Dobrável', 'Aquecimento de Fibra de Carbono', 'Compacto e Portátil', 'Eficiente Energético'],
      specs: [
        { label: 'Modelo', value: 'JHL023-05' },
        { label: 'Nome do Produto', value: 'Aquecedor de Piso' },
        { label: 'Tensão', value: '220-240V~50Hz' },
        { label: 'Potência', value: '800W (máx.)' },
        { label: 'Configurações', value: '400W + 400W' },
        { label: 'Controle', value: 'Interruptor Rotativo' },
        { label: 'Elemento de Aquecimento', value: 'Tubo de Aquecimento de Fibra de Carbono x 2' },
        { label: 'Plugue', value: 'Plugue Europeu' },
        { label: 'Cabo', value: '1.8-1.9m' },
        { label: 'Material', value: 'Plástico, Aço' },
        { label: 'Característica', value: 'Alça Dobrável' }
      ]
    },
    p12: {
      name: 'JHL021-S',
      description: 'Aquecedor versátil com luz ambiente LED e alto-falante Bluetooth. Perfeito para criar um ambiente aconchegante.',
      longDescription:
        'JHL021-S é um aquecedor inovador que combina funcionalidade de aquecimento com recursos de entretenimento. Apresenta iluminação LED de 16 cores para criar a atmosfera perfeita em qualquer ambiente. Equipado com alto-falante Bluetooth para transmitir música do seu dispositivo móvel. O interruptor alternador controla as configurações de aquecimento, enquanto o controle remoto controla as funções Bluetooth e LED. Inclui proteção contra tombamento para segurança e malha CoolTouch para prevenir queimaduras. O tubo de aquecimento de fibra de carbono proporciona aquecimento rápido e eficiente. Ideal para salas de estar, quartos ou qualquer espaço interno onde você deseja calor e ambiente.',
      category: 'Aquecedor Portátil',
      features: ['Luz LED de 16 Cores', 'Alto-falante Bluetooth', 'Proteção contra Tombamento', 'Malha CoolTouch', 'Controle Remoto'],
      specs: [
        { label: 'Modelo', value: 'JHL021-S' },
        { label: 'Nome do Produto', value: 'Aquecedor LED com Bluetooth' },
        { label: 'Tensão', value: '220-240V~50Hz' },
        { label: 'Potência', value: '1500W' },
        { label: 'Controle', value: 'Interruptor Alternador (Aquecimento), Controle Remoto (Bluetooth e LED)' },
        { label: 'LED', value: 'Luz de 16 cores' },
        { label: 'Elemento de Aquecimento', value: '1 Tubo de Aquecimento de Fibra de Carbono' },
        { label: 'Plugue', value: 'Plugue Europeu' },
        { label: 'Cabo', value: '1.8-1.9m' },
        { label: 'Segurança', value: 'Proteção contra Tombamento, Malha CoolTouch' },
        { label: 'Material', value: 'Ferro, Alumínio' }
      ]
    },
    p13: {
      name: 'JHL004-B',
      description: 'Potente aquecedor halógeno de 3000W com poste telescópico. Altura ajustável para cobertura de aquecimento personalizada.',
      longDescription:
        'JHL004-B é um potente aquecedor de piso para terraço projetado para espaços externos e semi-externos. Apresenta dois tubos de aquecimento halógenos proporcionando aquecimento eficiente e confortável com três configurações de potência ajustáveis (1200W-1800W-3000W). O poste telescópico permite ajustar a altura de 1.6m até 2.08m, permitindo cobertura de aquecimento personalizada para diferentes áreas. Equipado com controle remoto e botão táctil para operação conveniente. Inclui proteção contra tombamento para segurança. A construção em ferro e alumínio garante durabilidade mantendo uma aparência elegante. Perfeito para terraços, patios, jardins e áreas de entretenimento ao ar livre.',
      category: 'Aquecedor Portátil',
      features: ['Alta Potência 3000W', 'Poste Telescópico', '3 Configurações de Aquecimento', 'Controle Remoto e Táctil', 'Proteção contra Tombamento'],
      specs: [
        { label: 'Modelo', value: 'JHL004-B' },
        { label: 'Nome do Produto', value: 'Aquecedor de Piso para Terraço' },
        { label: 'Tensão', value: '220-240V~50Hz' },
        { label: 'Potência', value: '3000W (máx.)' },
        { label: 'Configurações', value: '1200W-1800W-3000W' },
        { label: 'Controle', value: 'Controle remoto e botão táctil' },
        { label: 'Altura', value: 'Poste telescópico (1.6m - 2.08m)' },
        { label: 'Elemento de Aquecimento', value: '2 Tubos de Aquecimento Halógenos' },
        { label: 'Plugue', value: 'Plugue Europeu' },
        { label: 'Cabo', value: '1.8-1.9m' },
        { label: 'Segurança', value: 'Proteção contra Tombamento' },
        { label: 'Material', value: 'Ferro, Alumínio' }
      ]
    },
    p14: {
      name: 'JHL001-BZ',
      description: 'Eficiente aquecedor halógeno para terraço com design de poste fixo. Solução de aquecimento elegante e limpa para espaços externos.',
      longDescription:
        'JHL001-BZ é um aquecedor de terraço elegante e eficiente com design de poste fixo. Equipado com dois tubos de aquecimento halógenos proporcionando três configurações de potência ajustáveis (900W-1200W-2100W) para um calor confortável. O design coberto com tecido adiciona um toque elegante mantendo a funcionalidade. Tanto o controle remoto quanto o botão táctil permitem uma operação fácil. Inclui proteção contra tombamento para uso seguro. Os materiais de ferro e alumínio garantem durabilidade e distribuição eficiente do calor. Ideal para terraços cobertos, pérgolas e outros espaços semi-externos onde estilo e calor são igualmente importantes.',
      category: 'Aquecedor Portátil',
      features: ['3 Configurações de Aquecimento', 'Design de Tecido', 'Controle Remoto e Táctil', 'Proteção contra Tombamento', 'Aquecimento Halógeno Eficiente'],
      specs: [
        { label: 'Modelo', value: 'JHL001-BZ' },
        { label: 'Nome do Produto', value: 'Aquecedor de Tecido para Terraço' },
        { label: 'Tensão', value: '220-240V~50Hz' },
        { label: 'Potência', value: '2100W (máx.)' },
        { label: 'Configurações', value: '900W-1200W-2100W' },
        { label: 'Controle', value: 'Controle remoto e botão táctil' },
        { label: 'Altura', value: 'Poste fixo' },
        { label: 'Elemento de Aquecimento', value: '2 Tubos de Aquecimento Halógenos' },
        { label: 'Plugue', value: 'Plugue Europeu' },
        { label: 'Cabo', value: '1.8-1.9m' },
        { label: 'Segurança', value: 'Proteção contra Tombamento' },
        { label: 'Material', value: 'Ferro, Alumínio' }
      ]
    },
    p15: {
      name: 'JHD028-B',
      description: 'Potente aquecedor halógeno de 2000W montado no teto com três configurações de aquecimento. Perfeito para espaços internos com tetos altos.',
      longDescription:
        'JHD028-B é um aquecedor montado no teto projetado para aquecimento eficiente em espaços internos. Apresenta dois tubos de aquecimento halógenos proporcionando aquecimento poderoso e uniforme com três configurações ajustáveis (800W-1200W-2000W). A montagem no teto economiza espaço no chão enquanto proporciona excelente distribuição de calor de cima. Equipado com controle remoto e botão táctil para operação conveniente. A construção em alumínio e ferro garante durabilidade e condução de calor eficiente. Ideal para quartos com tetos altos, garagens, ateliês ou qualquer espaço onde a montagem no teto seja preferida. Proporciona calor constante e confortável sem ocupar espaço no chão.',
      category: 'Aquecedor Portátil',
      features: ['Montagem no Teto', '2 Tubos Halógenos', '3 Configurações de Aquecimento', 'Controle Remoto e Táctil', 'Economia de Espaço'],
      specs: [
        { label: 'Modelo', value: 'JHD028-B' },
        { label: 'Nome do Produto', value: 'Aquecedor de Teto' },
        { label: 'Tensão', value: '220-240V~50Hz' },
        { label: 'Potência', value: '2000W (máx.)' },
        { label: 'Configurações', value: '800W-1200W-2000W' },
        { label: 'Controle', value: 'Controle remoto e botão táctil' },
        { label: 'Elemento de Aquecimento', value: '2 Tubos de Aquecimento Halógenos' },
        { label: 'Plugue', value: 'Plugue Europeu' },
        { label: 'Cabo', value: '1.8-1.9m' },
        { label: 'Material', value: 'Alumínio, Ferro' }
      ]
    },
    p16: {
      name: 'JHG019-B',
      description: 'Aquecedor inteligente de carbono com função de temporizador. O design montado na parede economiza espaço enquanto proporciona calor poderoso.',
      longDescription:
        'JHG019-B é um aquecedor de terraço inteligente montado na parede apresentando tecnologia avançada de aquecimento de fibra de carbono. Apresenta três configurações ajustáveis para aquecimento poderoso e eficiente. Equipado com múltiplas opções de controle incluindo interruptor alternador, controle remoto e botão táctil para conveniência máxima. A função de temporizador de 8 horas proporciona economia de energia e tranquilidade. O tubo de aquecimento de carbono garante aquecimento rápido com excelente distribuição de calor. O design montado na parede economiza valioso espaço no chão enquanto proporciona aquecimento poderoso. Feito com construção durável de ferro e alumínio. Perfeito para terraços, garagens, ateliês ou qualquer espaço interno/externo onde a montagem na parede seja preferida.',
      category: 'Aquecedor Portátil',
      features: ['Montagem na Parede', 'Aquecimento de Carbono', 'Temporizador de 8 Horas', 'Múltiplas Opções de Controle', 'Design Economia de Espaço'],
      specs: [
        { label: 'Modelo', value: 'JHG019-B' },
        { label: 'Nome do Produto', value: 'Aquecedor de Parede para Terraço' },
        { label: 'Tensão', value: '220-240V~50Hz' },
        { label: 'Potência', value: '2000W (máx.)' },
        { label: 'Configurações', value: '650W-1300W-2000W' },
        { label: 'Interruptor', value: 'Interruptor alternador, controle remoto e controle táctil' },
        { label: 'Remoto', value: 'Sim' },
        { label: 'Temporizador', value: 'Sim, até 8 horas' },
        { label: 'Elemento de Aquecimento', value: 'Tubo de aquecimento de carbono' },
        { label: 'Plugue', value: 'Plugue Europeu' },
        { label: 'Cabo', value: '1.8-1.9m' },
        { label: 'Material', value: 'Ferro, Alumínio' }
      ]
    },
    p17: {
      name: 'JH-104',
      description: 'Aquecedor eficiente montado na parede com tubo halógeno ouro vermelho. Design compacto perfeito para espaços internos.',
      longDescription:
        'JH-104 é um aquecedor eficiente montado na parede projetado para espaços internos. Apresenta um tubo halógeno ouro vermelho que proporciona aquecimento rápido e eficiente. O design compacto com três configurações de aquecimento ajustáveis (800W/1300W/2000W) permite personalizar seu nível de conforto. Equipado com controle remoto para operação conveniente. O design elegante adapta-se perfeitamente a qualquer ambiente enquanto proporciona aquecimento poderoso. Ideal para salas de estar, quartos, escritórios ou qualquer espaço interno onde a montagem na parede seja preferida.',
      category: 'Aquecedor Portátil',
      features: ['Montado na Parede', 'Tubo Halógeno Ouro Vermelho', '3 Configurações de Aquecimento', 'Controle Remoto', 'Design Compacto'],
      specs: [
        { label: 'Modelo', value: 'JH-104' },
        { label: 'Nome do Produto', value: 'Aquecedor de Parede' },
        { label: 'Tensão', value: '220V ~ 50Hz' },
        { label: 'Potência', value: '2000W (máx.)' },
        { label: 'Configurações', value: '800W / 1300W / 2000W' },
        { label: 'Controle', value: 'Controle remoto' },
        { label: 'Elemento de Aquecimento', value: 'Tubo halógeno ouro vermelho' },
        { label: 'Plugue', value: 'Plugue Europeu' },
        { label: 'Cabo', value: '3m' },
        { label: 'Dimensões', value: '63.5cm × 10cm' },
        { label: 'Peso', value: '2.2kg' }
      ]
    },
    p18: {
      name: 'JH-106',
      description: 'Aquecedor compacto montado no teto com tecnologia de fibra de carbono. Perfeito para espaços internos pequenos.',
      longDescription:
        'JH-106 é um aquecedor compacto montado no teto projetado para aquecimento eficiente em espaços internos pequenos. Apresenta tecnologia de tubo de aquecimento de fibra de carbono para aquecimento rápido e eficiente. O interruptor de corda proporciona fácil controle de ligar/desligar. Três configurações de aquecimento ajustáveis (600W/1000W/1500W) permitem personalizar seu nível de conforto. A montagem no teto economiza espaço no chão enquanto proporciona excelente distribuição de calor. Ideal para quartos pequenos, banheiros, cozinhas ou qualquer espaço onde a montagem no teto seja preferida.',
      category: 'Aquecedor Portátil',
      features: ['Montado no Teto', 'Tecnologia de Fibra de Carbono', '3 Configurações de Aquecimento', 'Interruptor de Corda', 'Economia de Espaço'],
      specs: [
        { label: 'Modelo', value: 'JH-106' },
        { label: 'Nome do Produto', value: 'Aquecedor de Teto' },
        { label: 'Tensão', value: '220V ~ 50Hz' },
        { label: 'Potência', value: '1500W (máx.)' },
        { label: 'Configurações', value: '600W / 1000W / 1500W' },
        { label: 'Controle', value: 'Interruptor de corda' },
        { label: 'Elemento de Aquecimento', value: 'Tubo de aquecimento de fibra de carbono' },
        { label: 'Plugue', value: 'Plugue Europeu' },
        { label: 'Cabo', value: '3m' },
        { label: 'Dimensões', value: '42cm (diâmetro) × 30cm (altura)' },
        { label: 'Peso', value: '2.3kg' }
      ]
    },
    p19: {
      name: 'JH-3000',
      description: 'Aquecedor de terraço ajustável premium com controle por APP de smartphone. Perfeito para entretenimento ao ar livre.',
      longDescription:
        'JH-3000 é um aquecedor de terraço ajustável premium projetado para entretenimento ao ar livre. Apresenta tecnologia avançada de tubo de aquecimento de fibra de carbono para aquecimento poderoso e eficiente. A altura ajustável (160-205cm) permite personalizar a cobertura de aquecimento. Equipado com controle remoto e APP de smartphone para máxima conveniência. Três configurações de aquecimento ajustáveis (1200W/1800W/3000W) proporcionam conforto personalizável. A base robusta com diâmetro de 45cm garante estabilidade. Perfeito para terraços, pátios, jardins e áreas de entretenimento ao ar livre.',
      category: 'Aquecedor Portátil',
      features: ['Altura Ajustável', 'Aquecimento de Fibra de Carbono', '3 Configurações de Aquecimento', 'APP de Smartphone', 'Controle Remoto'],
      specs: [
        { label: 'Modelo', value: 'JH-3000' },
        { label: 'Nome do Produto', value: 'Aquecedor de Terraço Preto Ajustável' },
        { label: 'Tensão', value: '220V ~ 50Hz' },
        { label: 'Potência', value: '3000W (máx.)' },
        { label: 'Configurações', value: '1200W / 1800W / 3000W' },
        { label: 'Controle', value: 'Controle remoto e APP de smartphone' },
        { label: 'Elemento de Aquecimento', value: 'Tubo de aquecimento de fibra de carbono' },
        { label: 'Plugue', value: 'Plugue Europeu' },
        { label: 'Cabo', value: '5m' },
        { label: 'Altura', value: 'Ajustável, 160-205cm' },
        { label: 'Diâmetro da Base', value: '45cm' },
        { label: 'Peso', value: '12kg' }
      ]
    },
  },
};

